'use strict';

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} event - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(event) {
  var valid = true;
  if (this.checkValidity && !this.checkValidity()) {
    // safari
    valid = false;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }
    $(this)
      .find('input, select')
      .each(function() {
        if (!this.validity.valid) {
          $(this).trigger('invalid', this.validity);
        }
      });
  }
  return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearForm(form) {
  $(form)
    .find('.form-control.is-invalid')
    .removeClass('is-invalid');

  $(form)
    .find('.invalid-feedback')
    .removeClass('d-block');
}

module.exports = {
  invalid: function() {
    $('form input, form select').on('invalid', function(e) {
      e.preventDefault();
      this.setCustomValidity('');
      if (!this.validity.valid && this.id !== 'registration-form-bdate') {
        var validationMessage = this.validationMessage;
        $(this).addClass('is-invalid');
        if (this.validity.patternMismatch && $(this).data('pattern-mismatch')) {
          validationMessage = $(this).data('pattern-mismatch');
        }
        if ((this.validity.rangeOverflow || this.validity.rangeUnderflow) && $(this).data('range-error')) {
          validationMessage = $(this).data('range-error');
        }
        if ((this.validity.tooLong || this.validity.tooShort) && $(this).data('range-error')) {
          validationMessage = $(this).data('range-error');
        }
        if (this.validity.valueMissing && $(this).data('missing-error')) {
          validationMessage = $(this).data('missing-error');
        }
        $(this)
          .parents('.form-group')
          .find('.invalid-feedback')
          .text(validationMessage);
      }
    });
  },

  submit: function() {
    $('form').on('submit', function(e) {
      const form = $(this);

      // Contact Us validation
      // This is done here because the recaptcha validation calls
      // e.preventDefault and prevents the event from propagating.
      if (form.attr('id') === 'CaseCreationForm') {
        const firstNameField = $('#contactForm-fName');
        const firstName = firstNameField.length ? firstNameField.val() : '';
        const lastNameField = $('#contactForm-lName');
        const lastName = lastNameField.length ? lastNameField.val() : '';
        const messageField = $('#contactForm-textArea');
        const message = messageField.length ? messageField.val() : '';
        const departureDateField = $('#contactForm-departureDate');
        const departureDate = departureDateField.length ? departureDateField.val() : '';
        const today = new Date();
        const todayFormatted = today.toISOString().split('T')[0];

        const lowerFirstName = firstName.toLowerCase();
        const lowerLastName = lastName.toLowerCase();

        let shouldBlock = false;

        // Check first and last name
        if (lowerFirstName === lowerLastName) {
          shouldBlock = true;
        }

        // Check if first or last name equal to test
        if (lowerFirstName === 'test' || lowerLastName === 'test') {
          shouldBlock = true;
        }

        // Check the presence of urls in subject or message
        const urlRegex = /(https?:\/\/|www\.)[^\s]+/gi;
        if (urlRegex.test(message)) {
          shouldBlock = true;
        }

        // Check if departureDate value is acceptable
        if (departureDate !== '' && departureDate < todayFormatted) {
          shouldBlock = true;
        }

        if (shouldBlock) {
          e.preventDefault();
          $('#contactUsErrorField').addClass('d-block');
          window.scrollTo(0, 0);

          return;
        }
      }

      if (form.attr('id') === 'ComplaintCreationForm') {
        const orderNumber = $('#complaintForm-orderN');
        const isEmpty = !orderNumber.val().trim();

        const $departureD = $('#complaintForm-departureD');
        const $destination = $('#complaintForm-destination');

        if (isEmpty) {
            $departureD.prop('required', true);
            $destination.prop('required', true);

            if ($departureD.value === '') {
                $departureD.addClass('is-invalid');
            }

            if ($destination.value === '') {
                $destination.addClass('is-invalid');
            }

            $departureD.closest('.form-group').addClass('required');
            $destination.closest('.form-group').addClass('required');
        } else {
            $departureD.prop('required', false).removeClass('is-invalid');
            $destination.prop('required', false).removeClass('is-invalid');

            $departureD.closest('.form-group').removeClass('required');
            $destination.closest('.form-group').removeClass('required');
        }
      }

      var validateresp = validateForm.call(this, e);
      var isCaptchaEnable = $('#g-recaptcha-init').length;
      var captcha = $(this).find('.g-recaptcha').length ? $(this).find('.g-recaptcha') : $(this).find('#g-recaptcha-init');
      if (validateresp && isCaptchaEnable) {
        if (captcha.length) {
          var captchaDone = false;
          var gTokenClient = grecaptcha.getResponse();
          var submitidreq = $(this).find('input[name=idsubmit]').data('id');
          var action = $('.grec-info').data('uri');

          if (gTokenClient == '' || !submitidreq ) {
            captcha.addClass('is-invalid');
            captcha.siblings('.invalid-captcha').text('Bisogna accettare il captcha!');
            e.preventDefault();
          } else {
            $.ajax({
              url: action,
              method: 'GET',
              async: false,
              data: { gTokenClient: gTokenClient, submitidreq: submitidreq },
              success: function (data) {
                if (data.success) {
                  console.log("Accepted Cap");
                  captchaDone = true;
                  var button = $(this).find(':submit');
                  $.spinner().start();
                  button.attr('disabled', true);
                  // $(e.target).attr('action', data.urlResponse);
                  return true;
                } else {
                  captcha.addClass('is-invalid');
                  captcha.siblings('.invalid-feedback').text('ERROR Captcha: Captcha scaduto! Riavviare');
                  console.log(data.errorMessage);
                  e.preventDefault();
                }
              },
              error: function (e) {
                console.log('error captcha!');
              }
            });
          }
          return captchaDone;
        } else {
            var button = $(this).find(':submit');
            $.spinner().start();
            button.attr('disabled', true);
            return validateresp;
        }
      }
    });
  },
  buttonClick: function() {
    $('form button[type="submit"], form input[type="submit"]').on('click', function() {
      // clear all errors when trying to submit the form
      clearForm($(this).parents('form'));
    });
  },

  functions: {
    validateForm: function(form, event) {
      validateForm.call($(form), event || null);
    },
    clearForm: clearForm
  }
};
